import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { Platform } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { settings } from '../../settings';

type ReqParams = { [param: string]: string };
type Headers = {
  Authorization: string;
  'X-API-KEY': string;
  'Content-Type': string;
};

type httpMethod = 'get' | 'post' | 'put' | 'patch' | 'head' | 'delete' | 'options' | 'upload' | 'download';

@Injectable({
  providedIn: 'root',
})
export class NativeHttpProvider {
  constructor(
    private http: HTTP,
    private platform: Platform,
  ) {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.http.setDataSerializer('json');
        this.http.setRequestTimeout(settings.http.timeoutS);
      }
    });
  }

  request(
    method: string,
    url: string,
    headers: Headers,
    params?: ReqParams,
    body?: any,
    serializer?: any,
  ): Promise<any> {
    const data = params || body || {};
    const alteredMethod = method.toLowerCase();

    return this.platform.ready().then(() => {
      /// //This is to send request with serializer multipart for passing form data in post
      let httpRequest;
      if (serializer) {
        httpRequest = this.http.sendRequest(url, {
          method: alteredMethod as httpMethod,
          data: body,
          params,
          headers,
          serializer,
        });
      } else {
        httpRequest = this.http[alteredMethod](url, data, headers);
      }
      return httpRequest
        .then((rsp: any) => {
          const rspParams = rsp;

          rspParams.body = this.parsedData(rsp);
          rspParams.data = null;

          return Promise.resolve(rspParams);
        })
        .catch((error) => {
          const errorRsp = error;

          errorRsp.error = JSON.parse(error.error);
          return Promise.reject(errorRsp);
        });
    });
  }

  clearCookies() {
    if (this.platform.is('cordova')) {
      this.http.clearCookies();
    }
  }

  parsedData(rsp) {
    return typeof rsp.data === 'string' && rsp.status !== 204 ? JSON.parse(rsp.data) : {};
  }
}
